import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { CartProduct, Product, createCartProductFromProduct } from '@scalefast/core';
import { CartService } from '@scalefast/ecommerce-core';
import { Subscription } from 'rxjs';
import { AppAddToCartTemplateComponent } from 'src/app/shared/components/add-to-cart/add-to-cart-template/add-to-cart-template.component';
import { AppModalComponent } from 'src/app/shared/components/modal/modal.component';
import { AppProductPriceComponent } from '../../product-price/product-price.component';

@Component({
  selector: 'app-cross-sell-products-template',
  styleUrls: ['./cross-sell-products-template.styles.scss'],
  templateUrl: './cross-sell-products-template.component.html',
  standalone: true,
  imports: [AppProductPriceComponent, AppAddToCartTemplateComponent, AppModalComponent],
})
export class AppCrossSellProductsTemplateComponent implements OnDestroy {
  @Input() crossSellProducts: Product[] | null = [];
  @Output() addCrossSellProductToCartEvent = new EventEmitter<Product>();

  currentMaxQuantity: number = 0;
  maxQuantity$?: Subscription;
  uniqueModalId = Math.random().toString();

  @ViewChild('modalErrorComponentCartMaxValue') modalErrorComponentCartMaxValue: AppModalComponent;

  constructor(private cartService: CartService) {
    this.modalErrorComponentCartMaxValue = new AppModalComponent();

    this.maxQuantity$ = this.cartService.productsTillCartFull().subscribe((res) => {
      this.currentMaxQuantity = res;
    });
  }

  ngOnDestroy(): void {
    if (this.maxQuantity$) {
      this.maxQuantity$.unsubscribe();
    }
  }

  get crossSellProductsLength() {
    return this.crossSellProducts?.length ?? 0;
  }

  getCartCrossSellProduct(product: Product): CartProduct {
    return createCartProductFromProduct(product);
  }

  addCrossSellProductToCart(crossSellProduct: Product): void {
    this.addCrossSellProductToCartEvent.emit(crossSellProduct);
  }

  checkModalAndAddToCart(crossSellProduct: Product) {
    if (this.currentMaxQuantity == 0) {
      return this.modalErrorComponentCartMaxValue.show();
    }

    return this.addCrossSellProductToCart(crossSellProduct);
  }

  closeQuantityErrorCartMaxValueModal() {
    return this.modalErrorComponentCartMaxValue.close();
  }
}
